var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',{staticClass:"product-group-image-wrapper",attrs:{"title":_vm.name}},[(_vm.image)?_c('img',{staticClass:"product-group-image",attrs:{"src":_vm.image,"alt":_vm.name}}):_c('PlaceHolderImageGenerator',{staticClass:"product-group-image__placeholder",attrs:{"image-name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }